// extracted by mini-css-extract-plugin
export default {"eventInfo":"eventInfo__g_woRH","icon":"icon__ncLQpN","qrCode":"qrCode__atyUn3"};